import { getNotificationDeepLinkRoute } from './notificationRouting';

type PushNotificationAction = {
  notification?: {
    data?: {
      deepLinkPath?: unknown;
    } | null;
  } | null;
};

type HandlePushNotificationActionOptions = {
  currentOrigin?: string;
  navigate: (targetPath: string) => void;
};

export const handlePushNotificationAction = (
  action: PushNotificationAction,
  { currentOrigin, navigate }: HandlePushNotificationActionOptions
): string | null => {
  const normalizedRoute = getNotificationDeepLinkRoute(action.notification?.data, currentOrigin);

  if (!normalizedRoute) {
    return null;
  }

  navigate(normalizedRoute);
  return normalizedRoute;
};
